import { Package, Coins, Receipt, Users, TrendingUp } from "lucide-react";
import { pln } from "@/lib/api";

const Card = ({ icon: Icon, label, value, sub, testId, iconBg, glow }) => (
  <div data-testid={testId} className="rise group relative overflow-hidden rounded-2xl border border-border bg-card p-4 sm:p-5 transition-transform duration-300 hover:-translate-y-1">
    <div className={`pointer-events-none absolute -right-8 -top-8 h-28 w-28 rounded-full blur-2xl opacity-25 transition-opacity duration-300 group-hover:opacity-40 ${glow}`} />
    <div className="relative flex items-center gap-3">
      <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${iconBg}`}><Icon className="h-5 w-5" /></div>
      <p className="font-mono text-[10px] font-bold uppercase leading-tight tracking-widest text-muted-foreground">{label}</p>
    </div>
    <p className="relative mt-3 font-display text-2xl sm:text-3xl font-extrabold tabular-nums tracking-tight truncate">{value}</p>
    {sub && <p className="relative mt-1 text-xs text-muted-foreground truncate">{sub}</p>}
  </div>
);

export const StatCards = ({ stats, isAdmin }) => {
  if (!stats) return null;
  const suf = stats.basis === "created" ? "dodane" : "zafakt.";
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
      <Card icon={Receipt} label={`Zamówienia (${suf})`} value={stats.orders_count} sub={`Śr. wartość ${pln(stats.avg_order)}`} testId="stat-orders" iconBg="bg-blue-500/15 text-blue-400" glow="bg-blue-500" />
      <Card icon={Package} label={`Sztuki (${suf})`} value={stats.total_qty} sub={`${stats.customers_count} klientów`} testId="stat-qty" iconBg="bg-violet-500/15 text-violet-400" glow="bg-violet-500" />
      <Card icon={TrendingUp} label={`Sprzedaż netto (${suf})`} value={pln(stats.total_net)} sub={`brutto ${pln(stats.total_net * 1.23)}`} testId="stat-net" iconBg="bg-emerald-500/15 text-emerald-400" glow="bg-emerald-500" />
      <Card icon={isAdmin ? Users : Coins} label={isAdmin ? `Prowizje (${suf})` : `Moja prowizja (${suf})`} value={pln(stats.total_commission)} sub="wg stawek EMPRO" testId="stat-commission" iconBg="bg-amber-400/15 text-amber-400" glow="bg-amber-400" />
    </div>
  );
};
